import { createSlice } from '@reduxjs/toolkit';
import initialState from './initialState';
import {
  updatePeakPercentageReducer,
  updateNetworkReducer,
  toggleDayReducer,
  setEditModeReducer
} from './campaignOptionReducer';

export const campaignOptionSlice = createSlice({
  name: 'campaignOption',
  initialState,
  reducers: {
    updatePeakPercentage: updatePeakPercentageReducer,
    updateNetwork: updateNetworkReducer,
    toggleDay: toggleDayReducer,
    setEditMode: setEditModeReducer
  }
});

export const { updatePeakPercentage, updateNetwork, toggleDay, setEditMode } =
  campaignOptionSlice.actions;

export default campaignOptionSlice.reducer;
